import React from 'react';
import { Hero } from './components/Hero';
import { WhatIsAntiImpulso } from './components/WhatIsAntiImpulso';
import { WhoIsItFor } from './components/WhoIsItFor';
import { WhyItFails } from './components/WhyItFails';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { Expectations } from './components/Expectations';
import { TargetAudience } from './components/TargetAudience';
import { FAQ } from './components/FAQ';
import { FooterCTA } from './components/FooterCTA';
import { FallingMoney } from './components/FallingMoney';
export function App() {
  return <div className="min-h-screen w-full bg-[#FFF5F0] overflow-x-hidden relative" data-id="element-0">
      <FallingMoney data-id="element-1" />
      <div className="relative" style={{
      zIndex: 1
    }} data-id="element-2">
        <Hero data-id="element-3" />
        <WhatIsAntiImpulso data-id="element-4" />
        <WhoIsItFor data-id="element-5" />
        <WhyItFails data-id="element-6" />
        <Mechanism data-id="element-7" />
        <WhatYouGet data-id="element-8" />
        <Expectations data-id="element-9" />
        <TargetAudience data-id="element-10" />
        <FAQ data-id="element-11" />
        <FooterCTA data-id="element-12" />
      </div>
    </div>;
}